import { render } from "./Home.vue?vue&type=template&id=05710501&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=05710501&lang=css"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__